import {internalProps} from '../types/BS_types'
import {defaultRequestPoolSize, RequestsPool} from '../utils/requestQueue'

export const buildDetailsQueue = new RequestsPool(
  internalProps['teamcity.ui.requestPoolSize'] ?? defaultRequestPoolSize,
)
